const NewCommonButton = ({onClick, disabled, children, className}) => {
  return (
    <button
      type="button"
      disabled={disabled}
      onClick={onClick}
    //   className="flex h-10 w-full items-center justify-center rounded-[10px] bg-[#4ab933] text-sm font-semibold leading-[21px] text-white custom-transition enabled:hover:bg-[#3fa82c] disabled:cursor-not-allowed disabled:opacity-50"
      className={`flex h-10 w-full items-center justify-center rounded-[10px] 
      bg-[#4ab933] text-sm font-semibold leading-[21px] text-white 
      custom-transition enabled:hover:bg-[#3fa82c] disabled:cursor-not-allowed disabled:opacity-50 ${className || ''}`}
    >
      {children}
    </button>
  );
};

export default NewCommonButton;
